module.exports = __webpack_public_path__ + "img/gintzin.0de28d8c.png";